function calcPage (query) {
  let totalPage = parseInt((query.total - 1) / query.limit, 10) + ((query.total - 1) % query.limit)
  return totalPage < query.page ? totalPage : query.page
}

function getKey () {
  return new Date().getTime() + Math.ceil(Math.random() * 1000000)
}

function hasClass (el, className) {
  if (!el || !className) {
    return false
  }

  let classList = el.classList
  for (let i = 0; i < classList.length; i++) {
    let clazz = classList[i]
    if (clazz === className) {
      return true
    }
  }

  return false
}

function isArray (o) {
  return Object.prototype.toString.call(o) === '[object Array]'
}

function isObject (o) {
  return Object.prototype.toString.call(o) === '[object Object]'
}

function isNumber (o) {
  return Object.prototype.toString.call(o) === '[object Number]'
}

function isDate (o) {
  return Object.prototype.toString.call(o) === '[object Date]'
}

function isRegExp (o) {
  return Object.prototype.toString.call(o) === '[object RegExp]'
}

function throwError (msg) {
  alert(msg)
  throw new Error(msg)
}

export { calcPage, getKey, hasClass, isArray, isObject, isNumber, isDate, isRegExp, throwError }
